module.exports = __webpack_public_path__ + "img/58.54474793.jpeg";